import React from "react";
import "./Labels1.css";
const Labels1=()=>{
    return (
   <div ClassName ="hello">
    <div className="heading1">Popular right now</div>
    <div className="heading2">samba</div>
    <hr></hr>
    <div className="heading3">spezial</div>
    <hr></hr>
    <div className="heading4">running shoes</div>
    <hr></hr>
    <div className="heading5">shoes</div>
    <hr></hr>
    <div className="heading6">cap</div>
<hr></hr>
   </div>
    );
};

export default Labels1;